"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ChevronRight = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));

var _ChevronLeft = _interopRequireDefault(require("@mui/icons-material/ChevronLeft"));

var _reactI18next = require("react-i18next");

var _colors = require("@mui/material/colors");

var _colors2 = require("../../colors");

var _common = require("../../common");

var _BrandButton = _interopRequireDefault(require("../BrandButton"));

var _SlideImage = _interopRequireDefault(require("./SlideImage"));

var _CircleSteps = _interopRequireDefault(require("../CircleSteps"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var loadImages = function loadImages(slides) {
  slides.forEach(function (slide) {
    var img = new Image();
    img.src = slide.url;
  });
};

var ImageSlideShow = function ImageSlideShow(_ref) {
  var images = _ref.images,
      Content = _ref.Content,
      onComplete = _ref.onComplete,
      backgroundColor = _ref.backgroundColor,
      height = _ref.height,
      width = _ref.width;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentSlideIdx = _useState2[0],
      setCurrentSlideIdx = _useState2[1];

  var currentImage = images[currentSlideIdx];
  (0, _react.useEffect)(function () {
    loadImages(images);
  }, [images]);

  var handleNext = function handleNext() {
    if (currentSlideIdx >= images.length - 1) {
      onComplete();
      return;
    }

    setCurrentSlideIdx(currentSlideIdx + 1);
  };

  var handleBack = function handleBack() {
    if (currentSlideIdx <= 0) return;
    setCurrentSlideIdx(currentSlideIdx - 1);
  };

  if (!currentImage) return null;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    sx: {
      height: '100%',
      boxShadow: _common.brandBoxShadow,
      borderRadius: '6px'
    }
  }, /*#__PURE__*/_react.default.createElement(_SlideImage.default, {
    height: height,
    width: width,
    highQuality: currentImage.url,
    lowQuality: currentImage.tinyUrl
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    container: true,
    justifyContent: "center",
    sx: {
      padding: '25px',
      margin: '0 auto',
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_CircleSteps.default, {
    steps: images.map(function (_, idx) {
      return {
        value: idx + 1,
        selected: currentSlideIdx >= idx
      };
    })
  })), Content && /*#__PURE__*/_react.default.createElement(Content, {
    currentSlideIdx: currentSlideIdx
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center",
    sx: {
      backgroundColor: backgroundColor,
      borderRadius: '0 0 6px 6px'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    sx: {
      padding: '15px',
      visibility: currentSlideIdx <= 0 ? 'hidden' : 'visible'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    role: "button",
    "aria-label": "back-button",
    color: "primary",
    onClick: handleBack,
    sx: {
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, null), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "button",
    sx: {
      textTransform: 'none',
      fontSize: '16px !important'
    }
  }, t('back')))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    sx: {
      padding: '15px'
    }
  }, /*#__PURE__*/_react.default.createElement(_BrandButton.default, {
    role: "button",
    "aria-label": currentSlideIdx === images.length - 1 ? 'done-button' : 'next-button',
    variant: "done",
    onClick: handleNext,
    sx: {
      display: 'grid',
      gridTemplateColumns: '80% 20%',
      background: currentSlideIdx === images.length - 1 ? _colors2.GREEN_PRIMARY : _colors.red[500],
      '&:hover': {
        background: currentSlideIdx === images.length - 1 ? _colors2.GREEN3 : _colors2.RED2
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "button",
    sx: {
      textTransform: 'none',
      fontSize: '16px !important',
      whiteSpace: 'nowrap'
    }
  }, currentSlideIdx === images.length - 1 ? t('done') : t('next')), currentSlideIdx !== images.length - 1 && /*#__PURE__*/_react.default.createElement(_ChevronRight.default, null)))));
};

var _default = ImageSlideShow;
exports.default = _default;